import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = {
  class: "modal fade",
  id: "storeModal",
  tabindex: "-1",
  "aria-labelledby": "confirm",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  ref: "modalRef"
}
const _hoisted_3 = { class: "modal-dialog modal-fullscreen" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h5", {
  class: "modal-title",
  id: "exampleModalLabel"
}, "Store", -1)
const _hoisted_7 = {
  class: "btn btn-primary me-3",
  "data-bs-dismiss": "modal",
  "aria-label": "Close",
  type: "button"
}
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = ["id", "data-id", "checked"]
const _hoisted_10 = { class: "d-flex justify-content-start align-items-center" }
const _hoisted_11 = { class: "symbol symbol-50px" }
const _hoisted_12 = { style: {"padding-left":"1em"} }
const _hoisted_13 = { class: "d-flex flex-center flex-wrap" }
const _hoisted_14 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      class: "ms-4 me-4 btn btn-link p-0",
      "data-bs-toggle": "modal",
      "data-bs-target": "#storeModal",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.saveBeforeChange && $setup.saveBeforeChange(...args)))
    }, " +Add "),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", null, [
              _createElementVNode("button", _hoisted_7, " Save " + _toDisplayString($setup.selectedId?.length || 0) + " Store Selected ", 1),
              _createElementVNode("button", {
                class: "btn btn-danger",
                "data-bs-dismiss": "modal",
                "aria-label": "Close",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.loadSavedSelectedId && $setup.loadSavedSelectedId(...args))),
                type: "button"
              }, " Cancel ")
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_Datatable, {
              ref: "tableRef",
              "table-header": $setup.storeTableHeader,
              "table-data": $setup.tableData,
              loading: $setup.isStoreLoading,
              total: $setup.totalStore
            }, _createSlots({
              "cell-no": _withCtx(({ index }) => [
                _createTextVNode(_toDisplayString(index +
                  1 +
                  _ctx.storeTableOption.rowsPerPage *
                    (_ctx.storeTableOption.currentPage - 1)), 1)
              ]),
              "cell-selectStore": _withCtx(({ row }) => [
                _createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  id: `checkbox${row.id}`,
                  "data-id": `${row.id}`,
                  onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.handleSelected && $setup.handleSelected(...args))),
                  checked: $setup.selectedId.includes(row.id)
                }, null, 40, _hoisted_9)
              ]),
              "cell-createdAt": _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString($setup.dateFormat(row.createdAt, 'DD/MM/YYYY')), 1)
              ]),
              "cell-packageName": _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(row.package?.name || '-'), 1)
              ]),
              "cell-owner": _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(row.owner?.name || '-'), 1)
              ]),
              "cell-storeDetail": _withCtx(({ row }) => [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", {
                      class: "custom-image-box",
                      style: _normalizeStyle(`background-image: url('${
                        row.image ||
                        'media/images/steam-question-mark-icon-29.jpg'
                      }')`)
                    }, null, 4)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("span", null, _toDisplayString(row.name), 1)
                  ])
                ])
              ]),
              "cell-moreDetail": _withCtx(({ row }) => [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_router_link, {
                    to: `/stores/${row.id}`
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_14, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr001.svg" })
                      ])
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ])
              ]),
              _: 2
            }, [
              _renderList($setup.storeTableHeader.filter(
                  (data) =>
                    ![
                      'selectStore',
                      'no',
                      'createdAt',
                      'storeDetail',
                      'owner',
                      'packageName',
                    ].includes(data.key)
                ), (item, i) => {
                return {
                  name: `cell-${item.key}`,
                  fn: _withCtx(({ row }) => [
                    _createElementVNode("div", null, _toDisplayString(row[`${item.key}`]), 1)
                  ])
                }
              })
            ]), 1032, ["table-header", "table-data", "loading", "total"])
          ])
        ])
      ])
    ], 512)
  ]))
}